import Handlebars from 'handlebars';
import $ from 'jquery';

function render(parameters){
  $('#view .view__hbs').empty();

  var context = parameters;

  //LOGO view selected
  if(parameters.view=='logo'){
    //SORT BY floor
    if(parameters.sortby=='floor'){
      if(parameters.floor || parameters.officeTower){
        $('#view .view__hbs').append(Handlebars.templates.StorelistlogoTemplate(context));
      }else{
        $('#view .view__hbs').append(Handlebars.templates.StorelistFloorTemplate(context));
      }
    }
    //SORT BY category
    else if(parameters.sortby=='category'){
      if(parameters.category){
        $('#view .view__hbs').append(Handlebars.templates.StorelistlogoTemplate(context));
      }else{
        $('#view .view__hbs').append(Handlebars.templates.StorelistCategoryTemplate(context));
      }
    }
    //SORT BY name
    else{
      $('#view .view__hbs').append(Handlebars.templates.StorelistlogoAlphabetTemplate(context));
    }
  }
  //LIST view selected
  else{
    //SORT BY floor
    if(parameters.sortby=='floor'){
      if(parameters.floor || parameters.officeTower){
        $('#view .view__hbs').append(Handlebars.templates.StorelistTemplate(context));
      }else{
        $('#view .view__hbs').append(Handlebars.templates.StorelistFloorTemplate(context));
      }
    }
    //SORT BY category
    else if(parameters.sortby=='category'){
      if(parameters.category){
        $('#view .view__hbs').append(Handlebars.templates.StorelistTemplate(context));
      }else{
        $('#view .view__hbs').append(Handlebars.templates.StorelistCategoryTemplate(context));
      }
      //SORT BY name
    }else{
      $('#view .view__hbs').append(Handlebars.templates.StorelistAlphabetTemplate(context));
    }
  }

}

export default {
  render
};
